import React from 'react';
import {Filter, FilterProps} from 'react-admin';

const VideoCategoryFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <></>
    </Filter>
);

export default VideoCategoryFilter;
